<script>
import { CSAT_RATINGS } from 'shared/constants/messages';

export default {
  props: {
    selectedRating: {
      type: Number,
      default: null,
    },
  },
  emits: ['selectRating'],
  data() {
    return {
      ratings: CSAT_RATINGS,
      greenSmileyImage: '/brand-assets/green_smiley_emoji.png',
    };
  },

  methods: {
    buttonClass(rating) {
      return [
        { selected: rating.value === this.selectedRating },
        { disabled: !!this.selectedRating },
        { hover: !!this.selectedRating },
        'emoji-button shadow-none text-3xl lg:text-4xl outline-none mr-8 w-[30%] rounded hover:bg-woot-700',
      ];
    },
    onClick(rating) {
      this.$emit('selectRating', rating.value);
    },
    isGreenSmiley(rating) {
      return rating.key === 'satisfied';
    },
  },
};
</script>

<template>
  <div class="customer-satisfcation mb-2">
    <div class="ratings flex py-5 px-0 justify-center">
      <button
        v-for="rating in ratings"
        :key="rating.key"
        :class="buttonClass(rating)"
        @click="onClick(rating)"
      >
        <div class="w-full py-4 rating-card">
          <p class="text-sm">
            {{ rating.key }}
          </p>
          <img
            v-if="isGreenSmiley(rating)"
            :src="greenSmileyImage"
            alt="Satisfied"
            class="green-smiley-img"
          />
          <span v-else>{{ rating.emoji }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.emoji-button {
  transition: transform 300ms;

  &.selected,
  &:hover,
  &:focus,
  &:active {
    transform: scale(1.32);
  }

  &.disabled {
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  }
}

.rating-card {
  background-color: #d3d3d3;
}

.green-smiley-img {
  width: 1.875rem;
  height: 1.875rem;
  margin: 0 auto;
  display: inline-block;
  vertical-align: middle;

  @media (min-width: 1024px) {
    width: 2.25rem;
    height: 2.25rem;
  }
}
</style>
